import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "Assigned User Id", key: "assignedUserId" },
    { label: "Assigned User", key: "assignedUserName" },
    { label: "Created By", key: "createdBy" },
    { label: "Created By Id", key: "createdById" },
    { label: "Created Date", key: "createdDate" },
    { label: "ID", key: "id" },
    {
      label: "Is Deleted",
      key: "isDeleted",
      format: (value) => (value ? "Yes" : "No"),
    },
    { label: "Kiosk Id", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "Message", key: "message" },
    { label: "Modified By", key: "modifiedBy" },
    { label: "Modified By Id", key: "modifiedById" },
    { label: "Modified Date", key: "modifiedDate" },
    { label: "Role Id", key: "roleId" },
    { label: "Role Name", key: "roleName" },
  ];

  return (
    <div className="main-form form-details">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key, format }) => (
          <div className="field col-12 md:col-4 mb-3" key={key}>
            <label>{label}</label>
            <p>{format ? format(rowData?.[key]) : rowData?.[key] ?? "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
